"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Tray", {
  enumerable: true,
  get: function () {
    return _tray.default;
  }
});
Object.defineProperty(exports, "TrayButton", {
  enumerable: true,
  get: function () {
    return _trayButton.default;
  }
});
Object.defineProperty(exports, "TrayClose", {
  enumerable: true,
  get: function () {
    return _trayClose.default;
  }
});
Object.defineProperty(exports, "TrayMenu", {
  enumerable: true,
  get: function () {
    return _trayMenu.default;
  }
});
Object.defineProperty(exports, "TrayTitle", {
  enumerable: true,
  get: function () {
    return _trayTitle.default;
  }
});
exports.default = void 0;
var _tray = _interopRequireDefault(require("./tray"));
var _trayButton = _interopRequireDefault(require("./tray-button"));
var _trayClose = _interopRequireDefault(require("./tray-close"));
var _trayMenu = _interopRequireDefault(require("./tray-menu"));
var _trayTitle = _interopRequireDefault(require("./tray-title"));
require("@ux/text/styles");
var _default = _trayMenu.default;
exports.default = _default;